export default "__VITE_ASSET__C_UqYUxR__"